import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./Workforce.css";

const WorkforceHero = () => {
  const navigate = useNavigate();

  return (
    <div
  className="
    font-epilogue text-center 
    flex flex-col items-center justify-center
    px-5
    py-[clamp(50px,10vw,100px)]
    bg-cover workforce-hero bg-center bg-no-repeat
  "

>
  <h1
    className="
      font-epilogue font-bold text-white leading-[1.2]
      mb-[clamp(14px,2.5vw,20px)]
      max-w-[900px]
      text-[clamp(28px,5vw,48px)]
    "
  >
    WorkForce Scheduler
  </h1>
  <p
    className="
      font-epilogue text-white opacity-95 leading-[1.7]
      mx-auto
      mb-[clamp(24px,5vw,36px)]
      max-w-[760px]
      text-[clamp(15px,2.4vw,18px)]
    "
  >
    Optimize Your Most Valuable Asset—Your People. Intelligently align your team
    with demand to boost productivity, control costs, and achieve your business goals.
  </p>
  <motion.button
    whileHover={{
      scale: 1.08,
      backgroundColor: "#ffffff",
      color: "#000000",
      boxShadow: "0 0 20px rgba(255, 255, 255, 0.6)",
    }}
    whileTap={{ scale: 0.95 }}
    transition={{ duration: 0.25, ease: "easeOut" }}
    className="
      font-epilogue font-bold cursor-pointer
      bg-white text-[#1E72BB]
      py-[14px] px-[38px]
      rounded-[32px]
      text-[clamp(15px,1.2vw,18px)]
    "
    onClick={() => navigate("/schedule-a-demo")}
  >
    Schedule a Demo
  </motion.button>
</div>
  );
};

export default WorkforceHero;
